"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../theme"));
var _AlertError = _interopRequireDefault(require("../../icons/AlertError"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Box = _interopRequireDefault(require("../../components/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ValidationMessage = function ValidationMessage(_ref) {
  var message = _ref.message,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'error' : _ref$variant,
    id = _ref.id;
  var color = variant === 'error' ? _theme["default"].errorDark : _theme["default"].warningDark;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    "aria-hidden": "true",
    display: "flex",
    as: "span",
    pt: "space05",
    pr: "space05"
  }, /*#__PURE__*/_react["default"].createElement(_AlertError["default"], {
    color: color,
    size: 16
  })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    role: "alert",
    id: id,
    style: {
      color: color
    }
  }, message));
};
ValidationMessage.propTypes = {
  message: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].oneOf(['error', 'warning']).isRequired,
  id: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = ValidationMessage;